// extracted by mini-css-extract-plugin
export default {"root":"Blog-module-root","section":"Blog-module-section","wrapper":"Blog-module-wrapper","header":"Blog-module-header","title":"Blog-module-title","subtitle":"Blog-module-subtitle"};